import axios from 'axios';
import router from '../router'


const instance = axios.create({
  //has transferred to config.json
  //baseURL : config.VUE_CONFIG_APP_API     
});


//set default header
instance.setAuthHeader = function(token){   
  instance.defaults.headers.common['authorization'] = `Bearer ${token}`;  
  //instance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
}

instance.clearAuthHeader = function(){   
  instance.defaults.headers.common['authorization'] = '';
}

/* instance.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  if (error.response.status === 403 && !originalRequest._retry) {   
    console.log(error);
  }
  return Promise.reject(error);
});
 */

export default instance;

